<div class="content p-3">
    <div class="row mx-0 pb-2">
        <div class="col-12 px-0">
            <div class=" section-header d-flex justify-content-between">
                <h8 class="lato-regular color-whaleTail ml-2" cvLocalizedText langSection="Users" langKey="Profile">Profile</h8>
                <button type="button" class="icon-btn fill-cerulean fill-hover-ceruleanHover mb-2"
                        *ngIf="createOrWriteAccess() && !editing" (click)="editUserBtn()">
                    <svg class="icon-16">
                        <use href="../../../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use>
                    </svg>
                </button>
            </div>
        </div>
    </div>
    <ng-container *ngIf="editing; then editBlock else displayBlock"></ng-container>
    <ng-template #displayBlock>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Username">Username</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">
                    {{user.LoginName}}
                    <span *ngIf="user.AccountLocked && createOrWriteAccess()">
                        <svg class="icon-12 fill-redRyder"><use href="../App_Themes/clearview-default/icons/utility/lock.svg#lock"></use></svg>
                        <span class="color-redRyder body-2">User has been locked out due to multiple failed login attempts</span>
                        <br>
                        <button type="button" class="btn btn-secondary btn-sm" (click)="unlockAccount(user.LoginID)" [disabled]="unlockingAccount">Unlock Login Access</button>
                        <button type="button" class="btn btn-primary btn-sm" (click)="resetPassword(user.LoginID)" [disabled]="resettingPassword">Force Reset Password</button>
                    </span>
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="First_Name">First Name</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user?.FirstName}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Last_Name">Last Name</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user?.LastName}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Email_Details">Email</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user?.Email}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Language">Language</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{language}}</p>
            </div>
        </div>
        <div class="row" *ngIf="timezoneInfo.defaultCompanyTimeZone != 'Not Set'">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Time_Zone" langKey="Time_Zone">Time Zone</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user.TimeZoneInfoName}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Bio">Bio</p>
            </div>
            <div class="col-8">
                <textarea id="bio_txt" class="form-control color-whaleTail" readonly cols="60" row="5">{{userProfile?.Bio}}</textarea>
            </div>
        </div>
        <div class="attributeBreak"></div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Role_Title">Role</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user?.ProfileName}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Type_Details">Type</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user?.RelatedGroupTypeName}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Level_Title">Level</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user?.RelatedGroupLevelName}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Linked_Data_Group">Linked Data Group</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user?.RelatedGroupName}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Parent_Group">Parent Group</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user?.ParentGroupName}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Security_Admin" langKey="Multi_Factor_Title">Multi-Factor Authentication</p>
            </div>
            <div class="col-4" [ngSwitch]="user?.MultiFactorStatus">
                <span class="color-whaleTail" *ngSwitchCase="0" cvLocalizedText langSection="Security_Admin" langKey="MFA_Status_Inactive">Inactive, Not Required</span>
                <span class="color-whaleTail" *ngSwitchCase="1" cvLocalizedText langSection="Security_Admin" langKey="MFA_Status_Active_NotRequired">Active, Not Required</span>
                <span class="color-whaleTail" *ngSwitchCase="2" cvLocalizedText langSection="Security_Admin" langKey="MFA_Status_Active_Required">Active, Required</span>
                <span class="color-whaleTail" *ngSwitchCase="3" cvLocalizedText langSection="Security_Admin" langKey="MFA_Status_Active_SecurityPolicyRequired">Active, Required by security policy</span>
            </div>
        </div>
        <div class="row" *ngIf="permissions?.ShouldShowSSO">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="SSO_Subject_Identifier">SSO Subject Identifier</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user?.ExternalID}}</p>
            </div>
        </div>
        <div class="row" *ngIf="createOrWriteAccess() && user?.MultiFactorStatus != 0">
            <div class="offset-3 col-4">
                <button type="button" class="btn btn-secondary btn-sm" (click)="resetMfaAuthenticator()" [disabled]="resettingMfaAuthenticator">
                    Reset Authenticator
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Quality_Notification">Quality Notification</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user?.ReceiveAlerts === true ? "&#x2714;": "---"}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Performance_Alert">Performance Alert</p>
            </div>
            <div class="col-4">
                <p class="color-whaleTail">{{user?.ReceivePOAlerts === true ? "&#x2714;": "---"}}</p>
            </div>
        </div>
    </ng-template>

    <ng-template #editBlock>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Username">Username</p>
            </div>
            <div class="col-4">
                <input class="form-control color-whaleTail" type="text" [(ngModel)]="editUser.LoginName"
                       [ngClass]="{'requiredInput': editUser.LoginName == null
                    || editUser.LoginName.trim() == ''}" />
                <span class="requiredText" cvLocalizedText langSection="Users" langKey="Required"
                      *ngIf="editUser.LoginName == null || editUser.LoginName.trim() == ''">
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="First_Name">First Name</p>
            </div>
            <div class="col-4">
                <input class="form-control color-whaleTail" type="text" [(ngModel)]="editUser.FirstName" />
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Last_Name">Last Name</p>
            </div>
            <div class="col-4">
                <input class="form-control color-whaleTail" type="text" [(ngModel)]="editUser.LastName" />
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Email_Details">Email</p>
            </div>
            <div class="col-4">
                <input class="form-control color-whaleTail" type="text" [(ngModel)]="editUser.Email"
                       (class)="{'requiredInput': editUser.Email == null || editUser.Email.trim() == ''}" />
                <span class="requiredText" cvLocalizedText langSection="Users" langKey="Required"
                      *ngIf="editUser.Email == null || editUser.Email.trim() == ''"></span>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Language">Language</p>
            </div>
            <div class="col-4">
                <select class="form-control" [(ngModel)]="editLanguage">
                    <option *ngFor="let opt of languages" [value]="opt.Value">
                        {{opt.Value == "NoneSet" ? "English (Company Default)" : opt.Value}}
                    </option>
                </select>
            </div>
        </div>
        <div class="row" *ngIf="timezoneInfo.defaultCompanyTimeZone != 'Not Set'">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Time_Zone" langKey="Time_Zone">Time Zone</p>
            </div>
            <div class="col-4">
                <select class="form-control color-whaleTail" [(ngModel)]="editUser.TimeZoneInfoName">
                    <option value="Not Set" cvLocalizedText langSection="Users" langKey="Default"
                            title="{{timezoneInfo.defaultCompanyTimeZone}}">
                        Company Default
                    </option>
                    <option *ngFor="let timezone of timezoneInfo.availableTimeZones" [value]="timezone"> {{timezone}} </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Bio">Bio</p>
            </div>
            <div class="col-8">
                <textarea id="bio_edit" class="form-control color-whaleTail" cols="60" rows="5" [(ngModel)]="editUserProfile.Bio"></textarea>
            </div>
        </div>
        <div class="attributeBreak"></div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Role_Title">Role</p>
            </div>
            <div class="col-4">
                <select class="form-control" [(ngModel)]="editUser.ProfileName">
                    <option *ngFor="let opt of profileDTOs" [value]="opt.ProfileName">{{opt.ProfileName}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Type_Details">Type</p>
            </div>
            <div class="col-4">
                <select class="form-control" [(ngModel)]="editUser.RelatedGroupTypeName" (change)="onRelatedGroupTypeChange($event)">
                    <option *ngFor="let opt of baseGroupTypes" [value]="opt">{{opt}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Level_Title">Level</p>
            </div>
            <div class="col-4">
                <select class="form-control" [(ngModel)]="editUser.RelatedGroupLevelName" (change)="onRelatedGroupLevelChange($event)">
                    <option disabled class="placeholder_option" value="" cvLocalizedText langSection="Users" langKey="Select">
                        Select
                    </option>
                    <option *ngFor="let opt of groupLevelOptions" [value]="opt.GroupTypeName">{{opt.GroupTypeName}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Linked_Data_Group">Linked Data Group</p>
            </div>
            <div class="col-4">
                <select class="form-control requiredInput" [(ngModel)]="editUser.RelatedGroupName"
                        [ngClass]="{'requiredInput': user.RelatedGroupID == null || user.RelatedGroupID < 0}"
                        (change)="onLDGroupChange($event)">
                    <option disabled class="placeholder_option" value="" cvLocalizedText langSection="Users" langKey="Select">
                        Select
                    </option>
                    <option *ngFor="let opt of ldGroupOptions" [value]="opt.GroupName">{{opt.GroupName}}</option>
                </select>
                <span class="requiredText" cvLocalizedText langSection="Users" langSection="Required" *ngIf="noDataGroupMessage!=''">
                    {{ noDataGroupMessage }}
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Parent_Group">Parent Group</p>
            </div>
            <div class="col-4">
                <p class="fieldValue">{{(editUser?.ParentGroupName == "")? "N/A" : editUser?.ParentGroupName}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Security_Admin" langKey="Multi_Factor_Title">
                    Multi-Factor Authentication
                </p>
            </div>
            <div class="col-4">
                <div class="form-check">
                    <input type="checkbox" id="editUserRequireMfa" class="form-check-input mr-1" [disabled]="editUser.MultiFactorStatus == 3"
                           [(ngModel)]="editUser.MultiFactorRequired" />
                    <label for="editUserRequireMfa" class="form-check-label" *ngIf="editUser.MultiFactorStatus != 3"
                           cvLocalizedText langSection="Security_Admin" langKey="Required">Required</label>
                    <label for="editUserRequireMfa" class="form-check-label" *ngIf="editUser.MultiFactorStatus == 3"
                           cvLocalizedText langSection="Security_Admin" langKey="Required_By_Security_Policy">Required by security policy</label>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="permissions.ShouldShowSSO">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="SSO_Subject_Identifier">SSO Subject Identifier</p>
            </div>
            <div class="col-4">
                <input class="form-control color-whaleTail" type="text" [(ngModel)]="editUser.ExternalID" />
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Quality_Notification">Quality Notification</p>
            </div>
            <div class="col-4">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="editUser.ReceiveAlerts" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-3 ml-2">
                <p class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Performance_Alert">Performance Alert</p>
            </div>
            <div class="col-4">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="editUser.ReceivePOAlerts" />
                </div>
            </div>
        </div>

        <div class="row d-flex justify-content-end mr-2">
            <button type="button" class="btn btn-text mr-2" (click)="cancelEdit()"
                    cvLocalizedText langSection="Users" langKey="Cancel_Button">
                Cancel
            </button>
            <button type="button" class="btn btn-primary" (click)="saveChanges()"
                    cvLocalizedText langSection="Users" langKey="Save_Changes"
                    [ngClass]="{disabled: saveDisabled()}">
                Save
            </button>
        </div>
    </ng-template>
</div>
